module.exports = __webpack_public_path__ + "static/img/spoon.b713044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/spoon.png
// module id = 459
// module chunks = 1